import '../index.scss';

export const RibbonSeparator = () => <div className="RibbonButton-separator">&nbsp;</div>;
